import axios from "@/plugins/axios";

import * as workers from "./workers";

export const user = {
    ...workers
}